import { invalidateResearchReports, invalidateResearchSessions } from "@app/queries/research";
import { notifications } from "@lib/notification/notification";
import { useWebSocket } from "@lib/websocket/useWebSocket";

/**
 * Invalidates research session/report queries when the owner receives research frames.
 * Frames are already owner-scoped by the backend, so no experiment filter is needed —
 * react-query only refetches queries that are currently mounted.
 */
export function useSubscribeResearchWebsocketEvents(): void {
  useWebSocket("research.status", () => void invalidateResearchSessions());

  // Progress line is persisted on the session row; the frame is a ping to refetch.
  useWebSocket("research.progress", () => void invalidateResearchSessions());

  useWebSocket("research.report_ready", () => {
    void invalidateResearchReports();
    void invalidateResearchSessions();
    // Runs take minutes, so the user is rarely looking at the chat when one lands. The frame
    // fires once per completed run, wherever they are in the app.
    notifications.success("Deep Research complete", "Your report is ready in the experiment's Research tab.");
  });
}
